import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TreeItemComponent } from './tree-item/tree-item.component';
import { TreeLabelComponent } from './tree-label/tree-label.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { PaginationComponent } from './pagination/pagination.component';

@NgModule({
  declarations: [TreeItemComponent, TreeLabelComponent, DateRangeComponent],
  exports: [TreeItemComponent, TreeLabelComponent, DateRangeComponent],
  imports: [CommonModule, IonicModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NewComponentsModule {}
